/**
 * 登记表二维码扫出来的页面(/sheets/:sheetId):手机上直接拍照上传,不用先找到课程。
 * 老师没登录会先走登录;没权限的课程后端返回 404。
 */
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";

import { getPrintSheet } from "../../api/gpa";
import { ScanDraftModal } from "./ScanDraftModal";

export function SheetLandingPage(): JSX.Element {
  const { t } = useTranslation();
  const { sheetId = "" } = useParams();
  const nav = useNavigate();
  const sheet = useQuery({ queryKey: ["print-sheet", sheetId], queryFn: () => getPrintSheet(sheetId), enabled: !!sheetId });
  if (sheet.isLoading) return <p className="text-sm text-slate-500">{t("common.loading")}</p>;
  if (!sheet.data) return <p className="text-sm text-rose-600">{t("gpa.grades.scan.sheetMissing")}</p>;
  const s = sheet.data;
  return (
    <div className="mx-auto max-w-3xl">
      <Link to={`/classes/${s.class_id}/grades`} className="text-sm text-sky-600 hover:underline">{t("gpa.grades.back")}</Link>
      <h1 className="mb-1 mt-1 text-xl font-semibold text-slate-800">{s.class_name} · {s.item_label}</h1>
      <p className="mb-3 text-sm text-slate-500">{t("gpa.grades.scan.sheetInfo", { n: s.roster_snapshot.length, pages: s.pages, date: s.created_at.slice(0, 10) })}</p>
      <ScanDraftModal inline onClose={() => nav(`/classes/${s.class_id}/grades`)} />
    </div>
  );
}
